import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError } from "Utils";

/*export const getLatestTopics = ({
  token,
  limit,
  language = "fr",
  navCommunity,
  sourceToken = null
}) => {
  const requestUrl = `${TTP_API_URL}/media/forum/latest-topics`;

  return axios
    .get(requestUrl, {
      // cancelToken: getLatestTopicsSourceToken.token,
      params: {
        access_token: token,
        organization_id: navCommunity
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};*/

export const getLatestTopics = ({
  token,
  limit,
  language = "fr",
  community
  //sourceToken = null
}) => {
  const requestUrl = `${TTP_API_URL}/media/topic`;

  const fields = ["*", "user"];

  let filter = [
    {
      property: "language",
      value: language,
      operator: "eq"
    }
  ];

  if (community) {
    filter.push({
      property: "organization",
      value: community,
      operator: "eq"
    });
  }
  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];
  return axios
    .get(requestUrl, {
      // cancelToken: getLatestTopicsSourceToken.token,
      params: {
        access_token: token,
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        filter: JSON.stringify(filter),
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/topic.js